import React from 'react';
import ReactDom from 'react-dom';
import App from '../src/containers/App/App'
import './reset.css'



ReactDom.render(<App />, document.getElementById('root'));